/**
 * Quote Hub Utilities
 * Re-exports shared functions from @quotech/ui — quote-specific helpers below.
 */
export { cn, formatCurrency, formatDate } from '@quotech/ui'

export function formatPercentage(value: number): string {
  return `${value.toFixed(1)}%`
}

export function calculateMargin(cost: number, sell: number): number {
  if (sell === 0) return 0
  return ((sell - cost) / sell) * 100
}

export function calculateMarkup(cost: number, sell: number): number {
  if (cost === 0) return 0
  return ((sell - cost) / cost) * 100
}

export function getStatusColor(status: string): string {
  const statusColors: Record<string, string> = {
    draft: 'bg-gray-100 text-gray-800',
    pending_review: 'bg-yellow-100 text-yellow-800',
    approved: 'bg-blue-100 text-blue-800',
    sent: 'bg-purple-100 text-purple-800',
    accepted: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    expired: 'bg-gray-100 text-gray-500',
  }
  return statusColors[status] || 'bg-gray-100 text-gray-800'
}

export function getStatusLabel(status: string): string {
  const statusLabels: Record<string, string> = {
    draft: 'Draft',
    pending_review: 'Pending Review',
    approved: 'Approved',
    sent: 'Sent',
    accepted: 'Accepted',
    rejected: 'Rejected',
    expired: 'Expired',
  }
  return statusLabels[status] || status
}
